// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const env =  window.location.hostname.split('.')[0] === "staging" ? 'staging' :  window.location.hostname.split('.')[0] === "test" ? 'test' : window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === '0.0.0.0'|| window.location.hostname === '192.168.86.39' || window.location.hostname == 'dev.genoplot.com' ? 'development' : 'production' 
const awsmobile = {
  "authenticationFlowTypeSaved": "CUSTOM_AUTH",
  "aws_project_region": process.env['VUE_APP_aws_project_region'],
  "aws_content_delivery_bucket": process.env['VUE_APP_aws_content_delivery_bucket'],
  "aws_content_delivery_bucket_region": process.env['VUE_APP_aws_content_delivery_bucket_region'],
  "aws_content_delivery_url": process.env['VUE_APP_aws_content_delivery_url'],
  "aws_cognito_identity_pool_id": process.env['VUE_APP_aws_cognito_identity_pool_id'],
  "aws_cognito_region": process.env['VUE_APP_aws_cognito_region'],
  "aws_user_pools_id": process.env['VUE_APP_aws_user_pools_id'],
  "aws_user_pools_web_client_id": process.env['VUE_APP_aws_user_pools_web_client_id'],
  "aws_appsync_graphqlEndpoint": process.env['VUE_APP_aws_appsync_graphqlEndpoint'],
  "aws_appsync_region": process.env['VUE_APP_aws_appsync_region'],
  "aws_appsync_authenticationType": process.env['VUE_APP_aws_appsync_authenticationType'],
   "oauth": {
        "domain": process.env['VUE_APP_authDomain'],
				scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
        redirectSignIn: env == 'development' ? 'http://localhost:8080/' : env == 'staging' ? 'https://staging.genoplot.com/signin' : 'https://genoplot.com/signin',
        redirectSignOut: env == 'development' ? 'http://localhost:8080/' : env == 'staging' ? 'https://staging.genoplot.com/' : 'https://genoplot.com/',
        responseType: 'code',
        socialProviders: ['Google', 'Apple', 'Facebook']
   },
}
export default awsmobile;
